import { render, staticRenderFns } from "./VendorPerformanceDemo.vue?vue&type=template&id=1aea1ea0"
import script from "./VendorPerformanceDemo.vue?vue&type=script&lang=js"
export * from "./VendorPerformanceDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports